import React, { useEffect, useState } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { CoreButton, CoreIconButton } from 'src/components/core'
import { Icon } from '@iconify/react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import LandingPageSettings from 'src/components/landing-page-settings'
import { patchCourseLandingPageAction } from 'src/reducers/course/action'
import { useParams } from 'react-router-dom'
import { ButtonActionType, ButtonData, ButtonType } from 'src/model/button'
import { patchCollectionLandingPageAction } from 'src/reducers/collection/action'

const CoverHeader = props => {
  const { classes, url, course } = props
  const [copied, setCopied] = useState(false)
  const { id, page, subPage } = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const pageUrl = window.location.pathname.split('/')[1]
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )
  // Create a safe version of landingPageData with fallback to empty object
  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings || {} : collectionSettings || {}

  const handleClick = () => {
    const currentData = window.editor
      .getData()
      .replace(/<p class="empty-dom">&nbsp;<\/p>/g, '')
      .trim()
    const patchAction =
      pageUrl === 'mini-course'
        ? patchCourseLandingPageAction
        : patchCollectionLandingPageAction

    var landingPageSection = landingPageData?.sections.find(
      x => x.type === 'Header',
    )

    dispatch(
      patchAction(id, [
        {
          path: 'sections',
          value: [
            {
              type: 'Header',
              content: {
                alignment: landingPageSection.content.aligment,
                image: landingPageSection.content.image,
              },
            },
            {
              type: 'Main',
              content: {
                html: currentData,
              },
            },
          ],
        },
      ]),
    )
  }
  let latestSettings = null

  // Modified handleSettings function using the callback pattern
  const handleSettings = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          title: `<div style="display: flex; align-items: center; justify-content: center; gap: 8px; color: var(--mcg-dark, #002E47); font-family: Inter; font-size: 16px; font-weight: 400; line-height: 150%;">
            <Typography>Landing page settings</Typography>
          </div>`,
          type: MessageBoxType.INFO,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              'Cancel',
              ButtonActionType.NO,
              () => {
                dispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              'Save',
              ButtonActionType.YES,
              () => {
                if (latestSettings) {
                  // Create a patch request to update all settings
                  const patchAction =
                    pageUrl === 'mini-course'
                      ? patchCourseLandingPageAction
                      : patchCollectionLandingPageAction

                  dispatch(
                    patchAction(id, [
                      {
                        path: 'primaryColor',
                        value: latestSettings.primaryColor,
                      },
                      {
                        path: 'favicon',
                        value: latestSettings.favicon,
                      },
                      {
                        path: 'font',
                        value: latestSettings.font,
                      },
                      {
                        path: 'logo',
                        value: latestSettings.logo,
                      },
                      {
                        path: 'thumbnail',
                        value: latestSettings.thumbnail,
                      },
                      // SEO settings
                      {
                        path: 'seoKeywords',
                        value: latestSettings.seoKeywords,
                      },
                      {
                        path: 'seoDescription',
                        value: latestSettings.seoDescription,
                      },
                      {
                        path: 'seoIndexable',
                        value: latestSettings.seoIndexable,
                      },
                      // Advanced settings
                      {
                        path: 'headerScripts',
                        value: latestSettings.headerScript,
                      },
                      {
                        path: 'bodyScripts',
                        value: latestSettings.bodyScript,
                      },
                    ]),
                  )

                  Array.from(
                    document.getElementsByClassName(
                      'course-container-header-text',
                    ),
                  ).forEach(element => {
                    element.style.fontFamily = latestSettings.font
                  })
                  Array.from(
                    document.getElementsByClassName('start-button-text-header'),
                  ).forEach(element => {
                    element.style.fontFamily = latestSettings.font
                  })
                  Array.from(
                    document.getElementsByClassName('start-button-text'),
                  ).forEach(element => {
                    element.style.fontFamily = latestSettings.font
                  })
                  Array.from(
                    document.getElementsByClassName('start-button-text-header'),
                  ).forEach(element => {
                    element.style.color = latestSettings.primaryColor
                  })
                  Array.from(
                    document.getElementsByClassName('start-button'),
                  ).forEach(element => {
                    element.style.color = latestSettings.primaryColor
                  })
                  const logoUrl = latestSettings.logo
                  if (logoUrl) {
                    const fullImageUrl = logoUrl.startsWith('http')
                      ? logoUrl
                      : `https://cdn.minicoursegenerator.com/${logoUrl}`

                    // Find the container element
                    const headerContainer = document.querySelector(
                      '.editor-header-img-container',
                    )

                    if (headerContainer) {
                      // Look for existing logo
                      let headerImage = headerContainer.querySelector(
                        '.header-logo',
                      )

                      // If logo exists, remove it
                      if (headerImage) {
                        headerImage.remove()
                      }

                      // Create new image element
                      headerImage = document.createElement('img')
                      headerImage.src = fullImageUrl
                      headerImage.className = 'header-logo'
                      headerImage.alt = 'logo'

                      // Append to container
                      headerContainer.appendChild(headerImage)
                    } else {
                      // If container doesn't exist, we may need to create it
                      const editorHeader = document.querySelector(
                        '.editor-header',
                      )

                      if (editorHeader) {
                        // Create container if it doesn't exist
                        const newHeaderContainer = document.createElement('div')
                        newHeaderContainer.className =
                          'editor-header-img-container'

                        // Create image
                        const headerImage = document.createElement('img')
                        headerImage.src = fullImageUrl
                        headerImage.className = 'header-logo'
                        headerImage.alt = 'logo'

                        // Append image to container and container to header
                        newHeaderContainer.appendChild(headerImage)
                        editorHeader.appendChild(newHeaderContainer)
                      }
                    }
                  } else {
                    const headerContainer = document.querySelector(
                      '.editor-header-img-container',
                    )

                    if (headerContainer) {
                      // Look for existing logo
                      let headerImage = headerContainer.querySelector(
                        '.header-logo',
                      )

                      // If logo exists, remove it
                      if (headerImage) {
                        headerImage.remove()
                      }
                    }
                  }
                }

                dispatch(messageBoxHideAction())
              },
            ),
          ],
          component: (
            <LandingPageSettings
              onSave={settings => {
                // This callback will be called whenever settings change
                latestSettings = settings
              }}
            />
          ),
          maxWidth: '960px',
          maxHeight: '80vh',
        }),
      ),
    )
  }
  const closeEditor = () => {
    if (pageUrl === 'mini-course') {
      history.push('/mini-course/' + id + '/landing-page')
    } else {
      history.push('/collection/' + id + '/landing-page')
    }

    window.scrollTo(0, 0)
  }

  return (
    <div className={classes.content}>
      <div className={classes.header}>
        <div className={classes.closeButton}>
          <CoreButton
            startIcon={<Icon icon="eva:close-outline" />}
            color="secondary"
            variant="text"
            size="small"
            onClick={closeEditor}
          >
            Close Editor
          </CoreButton>
        </div>
        <div className={classes.buttonDiv}>
          <CoreButton
            onClick={() => handleSettings()}
            size="small"
            color="secondary"
            variant="text"
          >
            Settings
          </CoreButton>
          <CoreButton
            onClick={() => handleClick()}
            size="small"
            color="secondary"
            variant="contained"
          >
            Save changes
          </CoreButton>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(CoverHeader)
